import posthog from 'posthog-js';

const isAnalyticsEnabled = () => Boolean(process.env.REACT_APP_POSTHOG_KEY);

export const identifyAnalyticsUser = (user) => {
    if (!isAnalyticsEnabled() || !user?._id) return;

    posthog.identify(user._id, {
        email: user.email,
        role: user.role,
        registrationStatus: user.registrationStatus,
        country: user.country,
        city: user.city,
    });
};

export const resetAnalyticsUser = () => {
    if (!isAnalyticsEnabled()) return;

    posthog.reset();
};

export const trackEvent = (eventName, properties = {}) => {
    if (!isAnalyticsEnabled() || !eventName) return;

    posthog.capture(eventName, {
        app: 'abroadify',
        environment: process.env.REACT_APP_ENV_NAME || 'local',
        ...properties,
    });
};